import React, { Component } from 'react';
import './titleWithIconBar.scss';

export default class IconBarItem extends Component {
    render = () => {
        const {className, children, ...otherProps} = this.props;
        return (
            <div className={`title-with-icon-bar-item ${className ? className : ''}`} {...otherProps}>
                <div className="title-with-icon-bar-item-icon">
                    {this.props.icon}
                </div>
                <div className="title-with-icon-bar-item-text">
                    {children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/titleWithIconBar/IconBarItem.js